jQuery(function($){
    // ------- helpers -------
    // Alt tags can hold multiple attributes separated by "|", e.g. 'Black | 5"'.
    // A slide shows when every attribute in its alt is part of the current
    // variant selection. Plain single-color alts ("Black") work as before.
    // "|" is the separator because color names already use "/" (Black/White).
    function norm(s){
      return (s||'').toString().toLowerCase().trim()
        .replace(/[“”″]/g,'"')  // curly double quotes / prime -> straight "
        .replace(/[‘’′]/g,"'")  // curly single quotes / prime -> straight '
        .replace(/\s*\/\s*/g,'/')
        .replace(/\s+/g,' ');
    }
    // Measurement values compare loosely: '7', '7"', '7 in', '7 inch',
    // '7 inches', '7" inseam' are all the same token, so the alt text
    // doesn't have to copy the option value's notation exactly.
    function canonToken(t){
      var m = t.match(/^(\d+(?:\.\d+)?)\s*(?:(?:"|in(?:ch(?:es)?)?\.?|inseam)\s*)*$/);
      return m ? m[1] : t;
    }
    function tok(s){
      return canonToken(norm(s));
    }
    function altTokens(alt){
      return (alt||'').toString().split('|').map(tok).filter(Boolean);
    }
    function colorCount($r){
    var set = Object.create(null);
    $mainLis($r).each(function(){
      var key = liColor($(this));
      if (key) set[key] = 1;
    });
    return Object.keys(set).length;
  }
  
    function $root(){
      return $('[data-section-type="product"], .product, .product-page').first();
    }
  
    // *** IMPORTANT: target only the HYDRATED list (has data-product-gallery-list) ***
    function $hydratedList($r){
      return $r.find('ul.product-gallery__media-list[data-product-gallery-list]').first();
    }
    function $mainLis($r){
      return $hydratedList($r).children('li.product-gallery__media-list-item');
    }
    function $thumbLis($r){
      // theme uses either of these; both are wired to the modal
      return $r.find('.product-gallery__navigation-thumbnail, .thumbnail-list__item');
    }
  
    function liAlt($li){
      var $img = $li.find('img[alt]').first();
      return $img.attr('alt') || '';
    }
    function liTokens($li){
      return altTokens(liAlt($li));
    }
    // first alt attribute is always the color
    function liColor($li){
      return liTokens($li)[0] || '';
    }

    function getSelectedColor($r){
      var $rad = $r.find('.input-swatch__input:checked');
      if ($rad.length) return $rad.val();
      var $sel = $r.find('select[name="options[Color]"]');
      if ($sel.length && $sel.val()) return $sel.val();
      var $btn = $r.find('[data-option-name="Color"] [aria-pressed="true"], [data-option-name="Color"] .is-selected');
      if ($btn.length) return $btn.attr('data-option-value') || $.trim($btn.text());
      return null;
    }

    // Every currently selected option value (color swatch, inseam radio, dropdowns)
    function getSelectedValues($r){
      var vals = [];
      $r.find('.options-selector .input-swatch__input:checked, .options-selector .input-radio__input:checked').each(function(){
        vals.push(tok($(this).val()));
      });
      $r.find('.options-selector .option-dropdown select').each(function(){
        if ($(this).val()) vals.push(tok($(this).val()));
      });
      $r.find('select[name^="options["]').each(function(){
        if ($(this).val()) vals.push(tok($(this).val()));
      });
      return vals.filter(Boolean);
    }
  
    function clearAllHiding($r){
      $mainLis($r).removeClass('dpc-hide').each(function(){ this.style.removeProperty('display'); });
      $thumbLis($r).removeClass('dpc-hide').each(function(){ this.style.removeProperty('display'); });
    }
  
    function showFirstTwoPerColor($r){
    clearAllHiding($r);
  
    // If there’s only one color on this product, show everything
    if (colorCount($r) <= 1){
      // nothing hidden
      return;
    }
  
    var seenM = Object.create(null);
    $mainLis($r).each(function(){
      var key = liColor($(this));
      if (!key) return;
      seenM[key] = (seenM[key] || 0) + 1;
      if (seenM[key] > 2) $(this).addClass('dpc-hide');
    });
  
    var seenT = Object.create(null);
    $thumbLis($r).each(function(){
      var key = altTokens($(this).find('img[alt]').first().attr('alt') || '')[0] || '';
      if (!key) return;
      seenT[key] = (seenT[key] || 0) + 1;
      if (seenT[key] > 2) $(this).addClass('dpc-hide');
    });
  
    if ($mainLis($r).not('.dpc-hide').length === 0){
      $mainLis($r).slice(0,6).removeClass('dpc-hide');
      $thumbLis($r).slice(0,6).removeClass('dpc-hide');
    }
  }
  
  
    // Filter the gallery against the full selection (all option values).
    // Tier 1: slides whose alt attributes ALL match the selection
    //         ('Black | 5"' when Black + 5" are selected, plain 'Black' too).
    // Tier 2: no full match -> fall back to color-only matching (legacy).
    // Tier 3: still nothing -> first-two-per-color default, never empty.
    function showForSelection($r, selectedValues){
      clearAllHiding($r);
      var sel = (selectedValues || []).map(tok).filter(Boolean);
      if (!sel.length){ showFirstTwoPerColor($r); return; }

      function tokensMatch(toks){
        return toks.length > 0 && toks.every(function(t){ return sel.indexOf(t) !== -1; });
      }

      var $m = $mainLis($r), anyFull = false;
      $m.each(function(){ if (tokensMatch(liTokens($(this)))) anyFull = true; });

      if (anyFull){
        $m.each(function(){
          if (!tokensMatch(liTokens($(this)))) $(this).addClass('dpc-hide');
        });
        $thumbLis($r).each(function(){
          var toks = altTokens($(this).find('img[alt]').first().attr('alt') || '');
          if (!tokensMatch(toks)) $(this).addClass('dpc-hide');
        });
        return;
      }

      // Tier 2: color-only match (any alt token equals the selected color,
      // so slides tagged in either order still filter by color)
      var target = tok(getSelectedColor($r) || sel[0]);
      if (target && colorCount($r) > 1){
        var any = false;
        $m.each(function(){
          if (liTokens($(this)).indexOf(target) !== -1) any = true;
          else $(this).addClass('dpc-hide');
        });
        $thumbLis($r).each(function(){
          var toks = altTokens($(this).find('img[alt]').first().attr('alt') || '');
          if (toks.indexOf(target) === -1) $(this).addClass('dpc-hide');
        });
        if (any) return;
        clearAllHiding($r);
      }

      showFirstTwoPerColor($r);
    }

    // kept for backwards compatibility with anything calling it directly
    function showOnlyColor($r, colorLabel){
      showForSelection($r, [colorLabel]);
    }
  
    var $r = $root();
    if (!$r.length) return;
  
    function apply(){
      // Wait until the hydrated gallery exists (has the zoom buttons)
      if (!$hydratedList($r).length){
        setTimeout(apply, 100);
        return;
      }
      clearAllHiding($r);
      var selected = getSelectedValues($r);
      if (selected.length) showForSelection($r, selected);
      else showFirstTwoPerColor($r);
    }

    $(window).on('load', function(){
      setTimeout(apply, 0);
      setTimeout(apply, 400); // in case hydration is a tick late
    });

    $(document).on('change', '.input-swatch__input, .options-selector .input-radio__input, .options-selector select, select[name^="options["]', function(){
      apply();
    });

    $(document).on('variant:change', function(e, payload){
      var v = payload && payload.variant;
      if (!v) return;
      var sel = [v.option1, v.option2, v.option3].filter(Boolean);
      if (sel.length) showForSelection($r, sel);
    });
  
    // Re-apply when the hydrated list is re-rendered by the theme
    var mo = new MutationObserver(function(m){
      if ($(document).find('ul.product-gallery__media-list[data-product-gallery-list]').length){
        setTimeout(apply, 0);
      }
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  });
  
  jQuery(function ($) {
    // -------- shared lookups --------
    function $root(){ return $('[data-section-type="product"], .product, .product-page').first(); }
    function $list($r){ return $r.find('ul.product-gallery__media-list[data-product-gallery-list]').first(); }
    function $items($r){ return $list($r).children('li.product-gallery__media-list-item'); }
    function isMobile(){ return window.matchMedia('(max-width: 719px)').matches; }
  
    // ------- VISIBLE index helpers -------
    function visibleIdx($r){
      var arr = [];
      $items($r).each(function(i){
        if (!$(this).hasClass('dpc-hide')) arr.push(i);
      });
      return arr;
    }
    function firstVisible($r){ var v = visibleIdx($r); return v.length ? v[0] : -1; }
    function lastVisible($r){ var v = visibleIdx($r); return v.length ? v[v.length-1] : -1; }
  
    // Current index = nearest slide by scrollLeft (robust if we’re between snaps)
    function currentNearestIndex($r){
      var L = $list($r)[0]; if (!L) return 0;
      var sl = L.scrollLeft, best = 1e9, idx = 0, els = $items($r).toArray();
      for (var i=0;i<els.length;i++){
        var d = Math.abs(els[i].offsetLeft - sl);
        if (d < best){ best = d; idx = i; }
      }
      // project onto visible set
      var vis = visibleIdx($r);
      if (!vis.length) return 0;
      // if current is hidden, pick the nearest visible neighbor
      if (vis.indexOf(idx) === -1){
        // find nearest visible by absolute distance in pixels
        var bestV = vis[0], bestD = 1e9;
        vis.forEach(function(v){
          var d = Math.abs(els[v].offsetLeft - sl);
          if (d < bestD){ bestD = d; bestV = v; }
        });
        return bestV;
      }
      return idx;
    }
  
    function goToIndex($r, idx, smooth){
      var L = $list($r)[0]; if (!L) return;
      var li = $items($r).get(idx); if (!li) return;
      // kill any pending smooth scroll so we don’t “fight”
      L.scrollTo({left: li.offsetLeft, behavior: smooth ? 'smooth' : 'auto'});
    }
  
    // Snap to first visible after *every* filter/apply to avoid “stuck” state
    function snapToFirstVisible($r){
      var i = firstVisible($r);
      if (i >= 0) goToIndex($r, i, false);
    }
  
    // ----- Wire arrows to skip hidden, using visible index model -----
    function wireArrows(){
      var $r = $root();
      var $wrap = $r.find('.product-gallery__navigation_arrows, .product-gallery__navigation--arrows, [data-product-gallery-navigation-arrows]').first();
      if (!$wrap.length) return;
      var $btns = $wrap.find('button');
      var $prev = $btns.filter('[aria-label*="Previous"],[data-direction="prev"]').first();
      var $next = $btns.filter('[aria-label*="Next"],[data-direction="next"]').first();
      if (!$prev.length) $prev = $btns.eq(0);
      if (!$next.length) $next = $btns.eq(1);
  
      $prev.off('.dpc-skip'); $next.off('.dpc-skip');
  
      function step(dir){
        var $r = $root();         // recalc each time (theme may re-render)
        var vis = visibleIdx($r); if (!isMobile() || !vis.length) return false;
        var cur = currentNearestIndex($r);
        // Map cur to its position within the visible set
        var pos = vis.indexOf(cur);
        if (pos === -1){
          // pick insertion point
          pos = vis.sort(function(a,b){return a-b;}).findIndex(function(v){ return v>cur; });
          if (pos < 0) pos = vis.length-1;
        }
        var nextPos = pos + (dir > 0 ? 1 : -1);
        if (nextPos < 0 || nextPos >= vis.length) return true; // at ends: let theme maybe handle wrap
        goToIndex($r, vis[nextPos], true);
        return true;
      }
  
      $prev.on('click.dpc-skip', function(e){
        if (!isMobile()) return;
        e.stopImmediatePropagation(); e.preventDefault();
        step(-1);
      });
      $next.on('click.dpc-skip', function(e){
        if (!isMobile()) return;
        e.stopImmediatePropagation(); e.preventDefault();
        step(1);
      });
    }
  
    // ---- Hook into your filter functions ----
    // Call this AFTER you finish showOnlyColor/showFirstTwoPerColor:
    function afterFilter(){
      var $r = $root();
      snapToFirstVisible($r);   // reset scroll to first visible of the current set
      wireArrows();             // rebind arrows against the new visible set
    }
  
    // If you don’t want to edit your existing functions, at least call afterFilter()
    // from the same places you already call wireArrows():
    $(document)
      .on('change', '.input-swatch__input, .options-selector .input-radio__input, .options-selector select, select[name^="options["]', function(){ setTimeout(afterFilter, 0); })
      .on('variant:change', function(){ setTimeout(afterFilter, 0); });
  
    $(window).on('load', function(){
      setTimeout(afterFilter, 0);
      setTimeout(afterFilter, 500); // after theme hydration
    });
  
    new MutationObserver(function(m){
      if (m.some(function(mm){ return $(mm.target).closest('[data-product-gallery-list]').length; })){
        setTimeout(afterFilter, 0);
      }
    }).observe(document.documentElement, {childList:true, subtree:true});
  });

  /* =========================================================================
     Hide variant combinations that DON'T EXIST (distinct from sold out).
     The product sections embed the product's variants as JSON in a
     <script data-edd-variant-data> tag inside each options-selector.
     Filtering is BIDIRECTIONAL: every option hides values with no existing
     variant for the selections in the other options — pick Black and 7"
     disappears if Black/7" was never created; pick 7" first and the colors
     that don't come in 7" disappear too.
     When a click conflicts with the other selection (Black clicked while 7"
     is selected but Black/7" doesn't exist), the click wins: the other
     option auto-switches to the first value that exists for it.
     Sold-out combinations still exist as variants, so they stay visible and
     keep the theme's normal sold-out treatment.
     ========================================================================= */
  jQuery(function($){
    var HIDE = 'edd-combo-hide';

    function norm(s){
      return (s||'').toString().toLowerCase().trim()
        .replace(/[“”″]/g,'"')
        .replace(/[‘’′]/g,"'")
        .replace(/\s*\/\s*/g,'/')
        .replace(/\s+/g,' ');
    }

    function readJSON($el){
      try { return JSON.parse($el.html()); } catch(e){ return null; }
    }

    // each option component inside the selector, ordered by option position
    function optionGroups($selector){
      return $selector
        .find('[data-component="option-selectable-boxes"], [data-component="option-dropdown"]')
        .map(function(){
          var data = readJSON($(this).find('script[data-component-data]').first()) || {};
          return { $el: $(this), position: data.position || 0 };
        })
        .get()
        .filter(function(g){ return g.position > 0; })
        .sort(function(a, b){ return a.position - b.position; });
    }

    function groupInputs(g){
      return g.$el.find('.input-swatch__input, .input-radio__input');
    }

    function selectedValue(g){
      var $checked = groupInputs(g).filter(':checked');
      if ($checked.length) return norm($checked.val());
      var $sel = g.$el.find('select[data-input]');
      if ($sel.length && $sel.val()) return norm($sel.val());
      return null;
    }

    // values of this option with an existing variant given the selections in
    // the OTHER options. Pass onlyPos to constrain by a single option instead
    // (used to resolve conflicting selections).
    function allowedValues(g, groups, data, onlyPos){
      var allowed = Object.create(null);
      data.variants.forEach(function(v){
        var ok = groups.every(function(other){
          if (other.position === g.position) return true;
          if (onlyPos && other.position !== onlyPos) return true;
          var sel = selectedValue(other);
          return !sel || norm(v.options[other.position - 1]) === sel;
        });
        if (ok) allowed[norm(v.options[g.position - 1])] = true;
      });
      return allowed;
    }

    function applySelector($selector, data){
      var groups = optionGroups($selector);
      if (groups.length < 2) return;

      // the option the USER last touched wins conflicts; programmatic
      // reselects don't update this (they dispatch untrusted events)
      var lastPos = $selector.data('eddLastChangedPosition') || 0;

      groups.forEach(function(g){
        var allowed = allowedValues(g, groups, data);

        // selections conflict (no variant exists for the combination):
        // relax to "exists with the last-clicked option" so the user's
        // click stands and everything else adapts around it
        if (!Object.keys(allowed).length && lastPos && g.position !== lastPos){
          allowed = allowedValues(g, groups, data, lastPos);
        }
        if (!Object.keys(allowed).length) return; // never hide a whole option

        var lostSelection = false;

        groupInputs(g).each(function(){
          var exists = !!allowed[norm($(this).val())];
          if (!exists && this.checked) lostSelection = true;
          // never visually hide the active selection; if it's invalid it
          // gets reselected below and hidden on the follow-up pass
          $(this).closest('.input-swatch, .input-radio').toggleClass(HIDE, !exists && !this.checked);
        });

        g.$el.find('select[data-input] option').each(function(){
          if (!this.value) return;
          var exists = !!allowed[norm(this.value)];
          if (!exists){
            this.hidden = true;
            if (!this.disabled){
              this.disabled = true;
              this.setAttribute('data-edd-combo-disabled', '');
            }
            if (this.selected) lostSelection = true;
          } else {
            this.hidden = false;
            if (this.hasAttribute('data-edd-combo-disabled')){
              this.disabled = false;
              this.removeAttribute('data-edd-combo-disabled');
            }
          }
        });

        // the value that was selected no longer exists for this combination:
        // move to the first one that does, and let the theme know — but
        // never override the option the user just clicked
        if (lostSelection && g.position !== lastPos){
          var $first = groupInputs(g).filter(function(){
            return !!allowed[norm($(this).val())];
          }).first();

          if ($first.length){
            $first.prop('checked', true);
            $first[0].dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            var $sel = g.$el.find('select[data-input]');
            var $opt = $sel.find('option').filter(function(){ return this.value && !!allowed[norm(this.value)]; }).first();
            if ($opt.length){
              $sel.val($opt.val());
              $sel[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    }

    function applyAll(){
      $('[data-component="options-selector"]').each(function(){
        var $selector = $(this);
        var data = readJSON($selector.find('script[data-edd-variant-data]').first());
        if (data && data.variants && data.variants.length) applySelector($selector, data);
      });
    }

    $(window).on('load', function(){
      applyAll();
      setTimeout(applyAll, 400); // after theme hydration
    });

    $(document).on('change', '[data-component="options-selector"] input, [data-component="options-selector"] select', function(e){
      // remember which option the USER touched (isTrusted excludes our own
      // programmatic reselects) so conflicts resolve in the user's favor
      if (e.originalEvent && e.originalEvent.isTrusted){
        var $group = $(this).closest('[data-component="option-selectable-boxes"], [data-component="option-dropdown"]');
        var gdata = readJSON($group.find('script[data-component-data]').first()) || {};
        if (gdata.position){
          $(this).closest('[data-component="options-selector"]').data('eddLastChangedPosition', gdata.position);
        }
      }
      setTimeout(applyAll, 0);
    });

    // re-apply if the theme re-renders the options (idempotent, so this settles)
    var comboTimer = null;
    new MutationObserver(function(muts){
      var relevant = muts.some(function(m){
        return $(m.target).closest('[data-component="options-selector"]').length;
      });
      if (!relevant) return;
      clearTimeout(comboTimer);
      comboTimer = setTimeout(applyAll, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  });

  /* =========================================================================
     Click a selected option again to DESELECT it.
     Radios can't be unchecked natively, so: remember whether the input was
     already checked when the pointer went down (before the browser processes
     the click), and if the click hits that same, already-selected value,
     uncheck it and fire a change event. The image filter and the
     combination filter both listen for change and fall back to their
     nothing-selected (page-load) state on their own.
     ========================================================================= */
  jQuery(function($){
    // The theme's JS rebuilds the option label ("Chosen Color: X") on change
    // and renders "undefined" when nothing is checked. Its own
    // "Choose a Color/Length/Size" string sits in the group's component data,
    // so put that back — deferred, to win over whatever the theme writes.
    function restoreLabel($group){
      if (!$group.length) return;
      if ($group.find('input:checked').length) return; // reselected meanwhile
      var data = {};
      try { data = JSON.parse($group.find('script[data-component-data]').first().html()) || {}; } catch(e){}
      if (data.choose_option) $group.find('[data-label]').first().text(data.choose_option);
    }

    $(document).on('pointerdown', '.input-swatch, .options-selector .input-radio', function(){
      var input = $(this).find('input[type="radio"]')[0];
      if (input) input.dataset.eddWasChecked = input.checked ? '1' : '';
    });

    $(document).on('click', '.input-swatch__input, .options-selector .input-radio__input', function(){
      if (this.dataset.eddWasChecked !== '1' || !this.checked) return;
      this.dataset.eddWasChecked = '';
      this.checked = false;
      $(this).closest('.input-swatch, .input-radio').removeAttr('data-checked');
      // no native change fires when re-clicking a checked radio, so no double-fire
      this.dispatchEvent(new Event('change', { bubbles: true }));

      var $group = $(this).closest('[data-component="option-selectable-boxes"], [data-component="option-dropdown"]');
      restoreLabel($group);
      setTimeout(function(){ restoreLabel($group); }, 0);
      setTimeout(function(){ restoreLabel($group); }, 150); // theme may update async
    });
  });
  
  
  
  // jQuery(document).ready(function ($) {
    
  //     // Function to update image and thumbnail visibility based on selected color variant
  //     function updateVisibility() {
  //     // Get the value of the selected color variant
  //     var selectedColor = $('.input-swatch[data-checked] .input-swatch__input:checked').val();
  
  //     // If no color variant is selected, show all images and thumbnails
  //     if (!selectedColor) {
  //         $('.product-gallery__media .lazy-img img, .product-gallery__navigation-thumbnail .lazy-img img').addClass('show');
  //     } else {
  //         // Remove 'show' class from all images and thumbnails
  //         $('.product-gallery__media .lazy-img img, .product-gallery__navigation-thumbnail .lazy-img img').removeClass('show');
  
  //         // Add 'show' class to images with alt tags matching the selected color
  //         $('.product-gallery__media .lazy-img img[alt="' + selectedColor + '"]').addClass('show');
  
  //         // Add 'show' class to thumbnails within list items with alt tags matching the selected color
  //         $('.product-gallery__navigation-thumbnail .lazy-img img[alt="' + selectedColor + '"]').addClass('show');
  //     }
  // }
  
  //     // Call the function when the page is fully loaded
  //     $(window).on('load', function () {
  //         updateVisibility();
  //     });
  
  //     // Call the function when a color variant is changed
  //     $('.input-swatch__input').change(function () {
  //         updateVisibility();
  //     });
  // });
  
  
  
  
  
  
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset = initialSrc;
  
      // Image source when header has shadow
      var shadowSrc = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage = $('.template-collection-athletic-club .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes = {
          'src': initialSrc,
          'srcset': initialSrcset,
          'width': logoImage.attr('width'),
          'height': logoImage.attr('height'),
          'alt': logoImage.attr('alt'),
          'data-rimg': logoImage.attr('data-rimg'),
          'data-rimg-scale': logoImage.attr('data-rimg-scale'),
          'data-rimg-template': logoImage.attr('data-rimg-template'),
          'data-rimg-max': logoImage.attr('data-rimg-max'),
          'data-rimg-crop': logoImage.attr('data-rimg-crop'),
          'style': logoImage.attr('style'),
          'data-rimg-template-svg': logoImage.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage() {
          // Check if header has shadow class
          var hasShadow = $('.template-collection-athletic-club .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow) {
              logoImage.attr(initialAttributes); // Restore initial attributes
              logoImage.attr('src', shadowSrc);
              logoImage.attr('srcset', shadowSrcset);
          } else {
              logoImage.attr(initialAttributes); // Restore initial attributes
              logoImage.attr('src', initialSrc);
              logoImage.attr('srcset', initialSrcset);
          }
      }
  
      // Call the function on page load
      updateLogoImage();
  
      // Call the function whenever the header shadow class changes
      $('.template-collection-athletic-club .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage();
      });
  
    
  });
  
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc2 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset2 = initialSrc2;
  
      // Image source when header has shadow
      var shadowSrc2 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset2 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage2 = $('.template-collection-social-club .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes2 = {
          'src': initialSrc2,
          'srcset': initialSrcset2,
          'width': logoImage2.attr('width'),
          'height': logoImage2.attr('height'),
          'alt': logoImage2.attr('alt'),
          'data-rimg': logoImage2.attr('data-rimg'),
          'data-rimg-scale': logoImage2.attr('data-rimg-scale'),
          'data-rimg-template': logoImage2.attr('data-rimg-template'),
          'data-rimg-max': logoImage2.attr('data-rimg-max'),
          'data-rimg-crop': logoImage2.attr('data-rimg-crop'),
          'style': logoImage2.attr('style'),
          'data-rimg-template-svg': logoImage2.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage2() {
          // Check if header has shadow class
          var hasShadow2 = $('.template-collection-social-club .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow2) {
              logoImage2.attr(initialAttributes2); // Restore initial attributes
              logoImage2.attr('src', shadowSrc2);
              logoImage2.attr('srcset', shadowSrcset2);
          } else {
              logoImage2.attr(initialAttributes2); // Restore initial attributes
              logoImage2.attr('src', initialSrc2);
              logoImage2.attr('srcset', initialSrcset2);
          }
      }
  
      // Call the function on page load
      updateLogoImage2();
  
    $('.template-collection-social-club .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage2();
      });
    
  });
  // COLLECTIONS 7.25
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc725 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset725 = initialSrc725;
  
      // Image source when header has shadow
      var shadowSrc725 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset725 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage725 = $('.template-collection-collections-7-25 .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes725 = {
          'src': initialSrc725,
          'srcset': initialSrcset725,
          'width': logoImage725.attr('width'),
          'height': logoImage725.attr('height'),
          'alt': logoImage725.attr('alt'),
          'data-rimg': logoImage725.attr('data-rimg'),
          'data-rimg-scale': logoImage725.attr('data-rimg-scale'),
          'data-rimg-template': logoImage725.attr('data-rimg-template'),
          'data-rimg-max': logoImage725.attr('data-rimg-max'),
          'data-rimg-crop': logoImage725.attr('data-rimg-crop'),
          'style': logoImage725.attr('style'),
          'data-rimg-template-svg': logoImage725.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage725() {
          // Check if header has shadow class
          var hasShadow725 = $('.template-collection-collections-7-25 .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow725) {
              logoImage725.attr(initialAttributes725); // Restore initial attributes
              logoImage725.attr('src', shadowSrc725);
              logoImage725.attr('srcset', shadowSrcset725);
          } else {
              logoImage725.attr(initialAttributes725); // Restore initial attributes
              logoImage725.attr('src', initialSrc725);
              logoImage725.attr('srcset', initialSrcset725);
          }
      }
  
      // Call the function on page load
      updateLogoImage725();
  
    $('.template-collection-collections-7-25 .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage725();
      });
    
  });
  
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc3 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset3 = initialSrc3;
  
      // Image source when header has shadow
      var shadowSrc3 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset3 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage3 = $('.template-collection .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes3 = {
          'src': initialSrc3,
          'srcset': initialSrcset3,
          'width': logoImage3.attr('width'),
          'height': logoImage3.attr('height'),
          'alt': logoImage3.attr('alt'),
          'data-rimg': logoImage3.attr('data-rimg'),
          'data-rimg-scale': logoImage3.attr('data-rimg-scale'),
          'data-rimg-template': logoImage3.attr('data-rimg-template'),
          'data-rimg-max': logoImage3.attr('data-rimg-max'),
          'data-rimg-crop': logoImage3.attr('data-rimg-crop'),
          'style': logoImage3.attr('style'),
          'data-rimg-template-svg': logoImage3.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage3() {
          // Check if header has shadow class
          var hasShadow3 = $('.template-collection .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow3) {
              logoImage3.attr(initialAttributes3); // Restore initial attributes
              logoImage3.attr('src', shadowSrc3);
              logoImage3.attr('srcset', shadowSrcset3);
          } else {
              logoImage3.attr(initialAttributes3); // Restore initial attributes
              logoImage3.attr('src', initialSrc3);
              logoImage3.attr('srcset', initialSrcset3);
          }
      }
  
      // Call the function on page load
      updateLogoImage3();
  
    $('.template-collection .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage3();
      });
    
  });
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc4 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset4 = initialSrc4;
  
      // Image source when header has shadow
      var shadowSrc4 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset4 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage4 = $('.template-index .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes4 = {
          'src': initialSrc4,
          'srcset': initialSrcset4,
          'width': logoImage4.attr('width'),
          'height': logoImage4.attr('height'),
          'alt': logoImage4.attr('alt'),
          'data-rimg': logoImage4.attr('data-rimg'),
          'data-rimg-scale': logoImage4.attr('data-rimg-scale'),
          'data-rimg-template': logoImage4.attr('data-rimg-template'),
          'data-rimg-max': logoImage4.attr('data-rimg-max'),
          'data-rimg-crop': logoImage4.attr('data-rimg-crop'),
          'style': logoImage4.attr('style'),
          'data-rimg-template-svg': logoImage4.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage4() {
          // Check if header has shadow class
          var hasShadow4 = $('.template-index .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow4) {
              logoImage4.attr(initialAttributes4); // Restore initial attributes
              logoImage4.attr('src', shadowSrc4);
              logoImage4.attr('srcset', shadowSrcset4);
          } else {
              logoImage4.attr(initialAttributes4); // Restore initial attributes
              logoImage4.attr('src', initialSrc4);
              logoImage4.attr('srcset', initialSrcset4);
          }
      }
  
      // Call the function on page load
      updateLogoImage4();
  
    $('.template-index .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage4();
      });
    
  });
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc5 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset5 = initialSrc5;
  
      // Image source when header has shadow
      var shadowSrc5 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset5 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage5 = $('.template-collection-headwear .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes5 = {
          'src': initialSrc5,
          'srcset': initialSrcset5,
          'width': logoImage5.attr('width'),
          'height': logoImage5.attr('height'),
          'alt': logoImage5.attr('alt'),
          'data-rimg': logoImage5.attr('data-rimg'),
          'data-rimg-scale': logoImage5.attr('data-rimg-scale'),
          'data-rimg-template': logoImage5.attr('data-rimg-template'),
          'data-rimg-max': logoImage5.attr('data-rimg-max'),
          'data-rimg-crop': logoImage5.attr('data-rimg-crop'),
          'style': logoImage5.attr('style'),
          'data-rimg-template-svg': logoImage5.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage5() {
          // Check if header has shadow class
          var hasShadow5 = $('.template-collection-headwear .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow5) {
              logoImage5.attr(initialAttributes5); // Restore initial attributes
              logoImage5.attr('src', shadowSrc5);
              logoImage5.attr('srcset', shadowSrcset5);
          } else {
              logoImage5.attr(initialAttributes5); // Restore initial attributes
              logoImage5.attr('src', initialSrc5);
              logoImage5.attr('srcset', initialSrcset5);
          }
      }
  
      // Call the function on page load
      updateLogoImage5();
  
    $('.template-collection-headwear .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage5();
      });
    
  });
  
  
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc6 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset6 = initialSrc6;
  
      // Image source when header has shadow
      var shadowSrc6 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset6 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage6 = $('.template-page-gateway-la .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes6 = {
          'src': initialSrc6,
          'srcset': initialSrcset6,
          'width': logoImage6.attr('width'),
          'height': logoImage6.attr('height'),
          'alt': logoImage6.attr('alt'),
          'data-rimg': logoImage6.attr('data-rimg'),
          'data-rimg-scale': logoImage6.attr('data-rimg-scale'),
          'data-rimg-template': logoImage6.attr('data-rimg-template'),
          'data-rimg-max': logoImage6.attr('data-rimg-max'),
          'data-rimg-crop': logoImage6.attr('data-rimg-crop'),
          'style': logoImage6.attr('style'),
          'data-rimg-template-svg': logoImage6.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage6() {
          // Check if header has shadow class
          var hasShadow6 = $('.template-page-gateway-la .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow6) {
              logoImage6.attr(initialAttributes6); // Restore initial attributes
              logoImage6.attr('src', shadowSrc6);
              logoImage6.attr('srcset', shadowSrcset6);
          } else {
              logoImage6.attr(initialAttributes6); // Restore initial attributes
              logoImage6.attr('src', initialSrc6);
              logoImage6.attr('srcset', initialSrcset6);
          }
      }
  
      // Call the function on page load
      updateLogoImage6();
  
    $('.template-page-gateway-la .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage6();
      });
    
  });
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc7 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset7 = initialSrc7;
  
      // Image source when header has shadow
      var shadowSrc7 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset7 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage7 = $('body[class^="template-page-city-"] .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes7 = {
          'src': initialSrc7,
          'srcset': initialSrcset7,
          'width': logoImage7.attr('width'),
          'height': logoImage7.attr('height'),
          'alt': logoImage7.attr('alt'),
          'data-rimg': logoImage7.attr('data-rimg'),
          'data-rimg-scale': logoImage7.attr('data-rimg-scale'),
          'data-rimg-template': logoImage7.attr('data-rimg-template'),
          'data-rimg-max': logoImage7.attr('data-rimg-max'),
          'data-rimg-crop': logoImage7.attr('data-rimg-crop'),
          'style': logoImage7.attr('style'),
          'data-rimg-template-svg': logoImage7.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage7() {
          // Check if header has shadow class
          var hasShadow6 = $('body[class^="template-page-city-"] .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow6) {
              logoImage7.attr(initialAttributes7); // Restore initial attributes
              logoImage7.attr('src', shadowSrc7);
              logoImage7.attr('srcset', shadowSrcset7);
          } else {
              logoImage7.attr(initialAttributes7); // Restore initial attributes
              logoImage7.attr('src', initialSrc7);
              logoImage7.attr('srcset', initialSrcset7);
          }
      }
  
      // Call the function on page load
      updateLogoImage7();
  
    $('body[class^="template-page-city-"] .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage7();
      });
    
  });
  
  jQuery(document).ready(function ($) {
      // Initial image source and srcset
      var initialSrc8 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-white.svg?v=1710545131';
      var initialSrcset8 = initialSrc8;
  
      // Image source when header has shadow
      var shadowSrc8 = 'https://cdn.shopify.com/s/files/1/0688/8951/0210/files/jpr-logo-black.svg?v=1710545131';
      var shadowSrcset8 = ''; // Update this with the correct srcset for the shadow state
  
      // Select the image element
      var logoImage8 = $('.template-collection-mother-s-day-collection .header__header .header__logo-image img');
  
      // Save initial attributes
      var initialAttributes8 = {
          'src': initialSrc8,
          'srcset': initialSrcset8,
          'width': logoImage8.attr('width'),
          'height': logoImage8.attr('height'),
          'alt': logoImage8.attr('alt'),
          'data-rimg': logoImage8.attr('data-rimg'),
          'data-rimg-scale': logoImage8.attr('data-rimg-scale'),
          'data-rimg-template': logoImage8.attr('data-rimg-template'),
          'data-rimg-max': logoImage8.attr('data-rimg-max'),
          'data-rimg-crop': logoImage8.attr('data-rimg-crop'),
          'style': logoImage8.attr('style'),
          'data-rimg-template-svg': logoImage8.attr('data-rimg-template-svg')
      };
  
      // Function to update image source and srcset based on header shadow class
      function updateLogoImage8() {
          // Check if header has shadow class
          var hasShadow8 = $('.template-collection-mother-s-day-collection .header__header').hasClass('header--shadow');
  
          // Set image attributes based on header shadow class
          if (hasShadow8) {
              logoImage8.attr(initialAttributes8); // Restore initial attributes
              logoImage8.attr('src', shadowSrc8);
              logoImage8.attr('srcset', shadowSrcset8);
          } else {
              logoImage8.attr(initialAttributes8); // Restore initial attributes
              logoImage8.attr('src', initialSrc8);
              logoImage8.attr('srcset', initialSrcset8);
          }
      }
  
      // Call the function on page load
      updateLogoImage8();
  
    $('.template-collection-mother-s-day-collection .header__header').on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
          updateLogoImage8();
      });
    
  });
  
  
  // $(document).ready(function() {
  //     // Iterate over each input element
  //     $('input[type="radio"]').each(function() {
  //         // Check if the input's value is 'XXS'
  //         if ($(this).val() === 'XXS') {
  //             // Hide the parent element with the 'input-radio' class
  //             // $(this).closest('.input-radio').hide();
  //                       $(this).closest('.input-radio').remove();
  
  //         }
  //     });
  // });
  // $(document).ready(function() {
  //     // Function to hide 'XXS' radio buttons
  //     function hideXXSRadios() {
  //         $('input[type="radio"]').each(function() {
  //             if ($(this).val() === 'XXS') {
  //                 // $(this).closest('.input-radio').hide();
  //               $(this).closest('.input-radio').remove();
  //             }
  //         });
  //     }
  
  //     // Initially hide 'XXS' radio buttons
  //     hideXXSRadios();
  
  //     // MutationObserver callback to re-apply hiding logic
  //     const observerCallback = (mutationsList, observer) => {
  //         for(let mutation of mutationsList) {
  //             if (mutation.type === 'childList') {
  //                 hideXXSRadios();
  //             }
  //         }
  //     };
  
  //     // Create a MutationObserver instance
  //     const observer = new MutationObserver(observerCallback);
  
  //     // Configuration for the observer (watch for added nodes)
  //     const observerConfig = { childList: true, subtree: true };
  
  //     // Start observing the document body for DOM changes
  //     observer.observe(document.body, observerConfig);
  // });
  // $(document).ready(function() {
  //     // Array of colors to hide
  //     var colorsToHide = ['Deep Crimson', 'French Fuchsia', 'Silver Lining'];
  
  //     // Iterate over each '.input-swatch__input'
  //     $('.input-swatch__input').each(function() {
  //         var $this = $(this); // Current input element
  //         // Check if the input's value is in the colorsToHide array
  //         if (colorsToHide.includes($this.val())) {
  //             // Hide the closest '.input-swatch' parent
  //             $this.closest('.input-swatch').hide();
  //         }
  //     });
  // });
  // $(document).ready(function() {
  //     // Function to hide specific colors
  //     function hideColors() {
  //         var colorsToHide = ['Deep Crimson', 'French Fuchsia', 'Silver Lining'];
  //         $('.input-swatch__input').each(function() {
  //             var $this = $(this); // Current input element
  //             if (colorsToHide.includes($this.val())) {
  //                 $this.closest('.input-swatch').hide();
  //             }
  //         });
  //     }
  
  //     // Initially hide colors
  //     hideColors();
  
  //     // MutationObserver callback to re-apply hiding logic
  //     const observerCallback = (mutationsList, observer) => {
  //         for(let mutation of mutationsList) {
  //             if (mutation.type === 'childList') {
  //                 hideColors();
  //             }
  //         }
  //     };
  
  //     // Create a MutationObserver instance
  //     const observer = new MutationObserver(observerCallback);
  
  //     // Configuration for the observer (watch for added nodes)
  //     const observerConfig = { childList: true, subtree: true };
  
  //     // Start observing the document body for DOM changes
  //     observer.observe(document.body, observerConfig);
  // });
  // $(document).ready(function() {
  //     // Array of colors to hide (ensure to match the case and spacing as in the data-color attribute)
  //     var collectionColorsToHide = ['deep crimson', 'french fuchsia', 'Silver Lining'];
  
  //     // Iterate over each button with a 'data-color' attribute
  //     $('button[data-color]').each(function() {
  //         var $this = $(this); // Current button element
  //         // Normalize the color value to lowercase for case-insensitive comparison
  //         var colorValue = $this.data('color').toLowerCase();
  
  //         // Check if the button's data-color value is in the collectionColorsToHide array
  //         if (collectionColorsToHide.includes(colorValue)) {
  //             // Hide the button
  //             $this.hide();
  //         }
  //     });
  // });
  // document.addEventListener("DOMContentLoaded", function() {
  //   var collectionColorsToHide = ['deep crimson', 'french fuchsia', 'Silver Lining'];
  
  //   // Function to hide buttons based on their data-color attribute
  //   function hideColorButtons() {
  //     document.querySelectorAll('button[data-color]').forEach(function(button) {
  //       var colorValue = button.getAttribute('data-color').toLowerCase();
  //       if (collectionColorsToHide.includes(colorValue)) {
  //         button.style.display = 'none';
  //       }
  //     });
  //   }
  
  //   // Initial check in case the buttons are already in the DOM
  //   hideColorButtons();
  
  //   // MutationObserver to observe changes in the DOM
  //   var observer = new MutationObserver(function(mutations) {
  //     mutations.forEach(function(mutation) {
  //       if (mutation.addedNodes.length) {
  //         hideColorButtons();
  //       }
  //     });
  //   });
  
  //   // Configuration of the observer:
  //   var config = { childList: true, subtree: true };
  
  //   // Pass in the target node, as well as the observer options
  //   observer.observe(document.body, config);
  // });
  // $(document).ready(function() {
  //   $('section[data-href]').click(function() {
  //     var href = $(this).attr('data-href');
  //     if (href) {
  //       window.location.href = href;
  //     }
  //   });
  // });
  
  $(document).ready(function() {
      $('.klaviyo-bis-trigger').css('visibility', 'hidden'); // Initially hide the notification
  
      function checkVariantAndStock() {
          var colorSelected = $('.input-swatch[data-checked]').length > 0; // Check if any color is selected
          var sizeOutOfStock = $('input-fieldset__values .input-radio[data-unavailable]').length > 0; // Check if any size is out of stock
  
          if (colorSelected && sizeOutOfStock) {
              $('.klaviyo-bis-trigger').css('visibility', 'visible');
          } else {
              $('.klaviyo-bis-trigger').css('visibility', 'hidden');
          }
      }
  
      // MutationObserver to watch for attribute changes
      var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if (mutation.type === "attributes") {
                  checkVariantAndStock(); // Trigger the check if any relevant attribute changes
              }
          });
      });
  
      // Configuration for the observer (which mutations to observe)
      var config = { attributes: true };
  
      // Start observing the target nodes for configured mutations
      $('.input-swatch, .input-radio').each(function() {
          observer.observe(this, config);
      });
  
      // Initial check in case the page loads with selections already made
      checkVariantAndStock();
  }); 
  $(document).ready(function() {
    console.log('Document ready');
  
    // Listen for clicks on color swatches
    $('body').on('click', '[data-component="input-swatch"]', function() {
      // Find the checked radio button within the clicked swatch component
      var $checkedRadio = $(this).find('input[type="radio"]:checked');
  
      // Check if the swatch component has a 'data-checked' attribute
      var isChecked = $(this).is('[data-checked]');
      console.log('Is checked:', isChecked, 'Value:', $checkedRadio.val());
  
      // Log the actual attribute value for debugging
      console.log('data-checked attribute:', isChecked);
  
      // Use a small delay to ensure the state is updated
      setTimeout(function() {
        // Check for data-unavailable and update visibility
        var foundUnavailable = false;
        $('[form="product-form-template--23116172230978__main"] [data-component="input-radio"]').each(function() {
          if ($(this).attr('data-unavailable') !== undefined) {
            foundUnavailable = true;
            console.log('Unavailable radio button found');
            return false; // Break out of the loop once the condition is met
          }
        });
  
        if (foundUnavailable) {
          $('.klaviyo-bis-trigger').addClass('visible');
          console.log('Klaviyo trigger made visible');
        } else {
          console.log('NNNOOOOOOO');
          $('.klaviyo-bis-trigger').removeClass('visible');
          console.log('Klaviyo trigger hidden');
        }
  
        // Log the current state of .klaviyo-bis-trigger
        console.log('.klaviyo-bis-trigger is visible:', $('.klaviyo-bis-trigger').hasClass('visible'));
      }, 500); // 10 milliseconds delay
    });
  });
  
  $(document).ready(function() {
    const variantsToHide = ['Bainbridge-Blue-No Logo', 'Clubhouse-White No Logo', 'Pritchard-Green-No Logo', 'Pure-Black-No Logo'];
  
    function hideVariants(selector) {
      $(selector).each(function() {
        const $input = $(this);
        if (variantsToHide.includes($input.val())) {
          $input.closest('.input-swatch').hide();
        }
      });
    }
  
    // Initial hide for elements present on page load
    hideVariants('input[name="Colortemplate--23116172198210__main"]');
    hideVariants('input[name="Colortemplate--23116172296514__main"]');
  
    // Use event delegation for dynamically added elements
    $(document).on('change', 'input[name^="Colortemplate--"]', function() {
      hideVariants(this);
    });
  
    // Set up a MutationObserver to watch for DOM changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          hideVariants('input[name^="Colortemplate--"]');
        }
      });
    });
  
    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
  });
  $(document).ready(function() {
    const variantsToHide = ['-no logo'];
  
    function hideNoLogoVariants() {
      $('[data-color]').each(function() {
        const $element = $(this);
        const color = $element.attr('data-color').toLowerCase();
        if (variantsToHide.some(variant => color.includes(variant))) {
          $element.hide();
        }
      });
    }
  
    // Initial hide for elements present on page load
    hideNoLogoVariants();
  
    // Set up a MutationObserver to watch for DOM changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          hideNoLogoVariants();
        }
      });
    });
  
    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  // document.addEventListener('DOMContentLoaded', function() {
  //   // Check if we're on the correct product page
  //   if (meta && meta.product && meta.product.id == 9597347397954) {
  //     hideSpecificVariant();
  
  //     // Set up a MutationObserver to handle dynamically loaded content
  //     const observer = new MutationObserver(hideSpecificVariant);
  //     observer.observe(document.body, { childList: true, subtree: true });
  //   }
  // });
  
  // function hideSpecificVariant() {
  //   const colorInputs = document.querySelectorAll('input[name^="Color"][value="Pure Black"]');
  //   colorInputs.forEach(input => {
  //     const swatch = input.closest('.input-swatch');
  //     if (swatch) {
  //       swatch.style.display = 'none';
  //     }
  //   });
  
  //   const sizeInputs = document.querySelectorAll('input[name^="Size"][value="XXS"]');
  //   sizeInputs.forEach(input => {
  //     const sizeOption = input.closest('.input-radio');
  //     if (sizeOption) {
  //       sizeOption.style.display = 'none';
  //     }
  //   });
  // }
  

  
  
  
  
  
  